import React, { useState, useEffect, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// import "../styles/TestimonialSection.css";

const testimonials = [
  { video: "https://www.youtube.com/embed/sgf5oNjnV58", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274900.png" },
  { video: "https://www.youtube.com/embed/4EXswTrf8XI", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274901-1-1.png" },
  { video: "https://www.youtube.com/embed/6hgI7h69a6M", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274904.png" },
  { video: "https://www.youtube.com/embed/td019sTQHF4", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274899-2.png" },
  { video: "https://www.youtube.com/embed/EQTVq5ulc60", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274900-2.png" },
  { video: "https://www.youtube.com/embed/2qvZ_QwJuqk", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274902-2.png" },
  { video: "https://www.youtube.com/embed/2d41dmSYptk", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274901-2.png" },
  { video: "https://www.youtube.com/embed/sXDkjOTY29I", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274899-3.png" },
  { video: "https://www.youtube.com/embed/YoFSPW4Np6c", thumb: "https://koderspedia.com/wp-content/uploads/2025/10/Frame-1171274902-1.png" },
];

export default function TestimonialSection() {
  const [activeVideo, setActiveVideo] = useState(null);

  const closeModal = useCallback(() => setActiveVideo(null), []);

  // Esc key se modal band + body scroll lock
  useEffect(() => {
    if (!activeVideo) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && closeModal();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [activeVideo, closeModal]);

  return (
    <section id="testimonial" className="leaders-section">
      <div className="work-content">
        <h2>
          What clients love about working with <strong>KodersPedia</strong>
        </h2>
        <p>
          Hear directly from clients about their experience working with KodersPedia.
        </p>
        {/* <h3>What clients love about working with KodersPedia</h3> */}
      </div>

      <div className="testimonial-swiper-wrap">
        <Swiper
          modules={[Navigation]}
          loop
          grabCursor
          spaceBetween={20}
          slidesPerView={1}
          navigation={{
            prevEl: ".testimonial-prev",
            nextEl: ".testimonial-next",
          }}
          breakpoints={{
            576: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 3, spaceBetween: 24 },
            1200: { slidesPerView: 4, spaceBetween: 30 },
          }}
        >
          {testimonials.map((item, i) => (
            <SwiperSlide key={i}>
              <button
                type="button"
                className="open-video-modal"
                onClick={() => setActiveVideo(item.video)}
                aria-label={`Watch client testimonial ${i + 1}`}
              >
                <h3 className="sr-only">Watch Our Client’s Experience</h3>
                <img src={item.thumb} alt="Client testimonial" loading="lazy" />
                <span className="watch-btn">Watch Testimonial</span>
              </button>
            </SwiperSlide>
          ))}
        </Swiper>

        <button type="button" className="testimonial-prev" aria-label="Previous slide" />
        <button type="button" className="testimonial-next" aria-label="Next slide" />
      </div>

      {activeVideo && (
        <div
          className="video-modal active"
          role="dialog"
          aria-modal="true"
          aria-label="Testimonial video"
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div className="video-modal-inner">
            <button
              type="button"
              className="video-modal-close"
              aria-label="Close video"
              onClick={closeModal}
            >
              &times;
            </button>
            <iframe
              src={`${activeVideo}?autoplay=1&rel=0&playsinline=1`}
              title="Client testimonial"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section> 
  );
}